<script lang="ts">
import { I3pService } from '@nuxtDatakodeUtils/services/i3p.service.js'
import { useCookie, useRuntimeConfig } from 'nuxt/app'
import FormInput from '@nuxtDatakodeUtils/components/form/input.vue'
import FormSelect from '@nuxtDatakodeUtils/components/form/select.vue'
import EntityInitSection from './EntityInitSection.vue'
import { useUserStore } from '~/store'

export default {
    name: 'CommandEntityPanelGlobalInfo',
    components: { FormInput, FormSelect },
    extends: EntityInitSection,
    props: {
        i3pService: { type: I3pService, required: true },
    },
    emits: ['updateData', 'save', 'updateMapPosition'],
    data() {
        const config = useRuntimeConfig()
        const userStore = useUserStore()
        const access_token = useCookie<string>('access_token')
        return {
            config,
            access_token,
            userStore,
        }
    },
    computed: {
        isAdmin(): boolean {
            return this.userStore?.currentUser?.role === 'admin'
        },
    },
    watch: {
    },
    mounted() {
    },
    methods: {
    },
}
</script>

<template>
    <FormSection v-if="data" title="Informations générales" with-borders-color="primary">
        <FormSelect
            v-if="data.status"
            data-key="status"
            :validation="validation?.status"
            :data
            :is-chips="true"
            :validation-rules="isAdmin ? validationRules : []"
            :translation-name
            @update-data="$emit('updateData', { [`status`]: $event })"
        />
        <FormInput
            data-key="name"
            :validation="validation?.name"
            :data
            :validation-rules
            :translation-name
            @update-data="$emit('updateData', { [`name`]: $event })"
        />

        <FormInput
            data-key="organization.name"
            :validation="validation?.organization_id"
            :data
            :validation-rules
            :translation-name
            @update-data="$emit('updateData', { [`organization_id`]: $event })"
        />

        <FormSelect
            data-key="matrice_type"
            :validation="validation?.matrice_type"
            :data
            :radio-buttons="true"
            :validation-rules
            :translation-name
            @update-data="$emit('updateData', { [`matrice_type`]: $event })"
        />
    </FormSection>
</template>
